var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-summary-container"},[_c('div',{staticClass:"backdrop",on:{"click":_vm.click}}),_c('div',{staticClass:"cart-bottom"}),_c('div',{staticClass:"cart-table-wrapper"},[_c('cart-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }